import { ReactNode } from 'react';

import styles from './TariffsSummaryItem.module.sass';

interface TariffItemProps {
  label: string;
  children: ReactNode;
}

export const TariffsSummaryItem = ({ label, children }: TariffItemProps) => {
  return (
    <div className={styles.item}>
      <div className={styles.label}>{label}</div>
      <div className={styles.children}>{children}</div>
    </div>
  );
};
